export const extractBreadcrumb = (breadcrumb: string, position: number): string => {
  if (!breadcrumb) return ''

  const [firstBreadcrumb = '', secondBreadcrumb = '', thirdBreadcrumb = '', fourthBreadcrumb = ''] =
    breadcrumb.split('>')
  return [firstBreadcrumb.trim(), secondBreadcrumb.trim(), thirdBreadcrumb.trim(), fourthBreadcrumb.trim()][position]
}
